import { View } from "binder"
import { JsCodeViewModel } from "./jsCode-viewModel"

export class JsCodeView extends View<JsCodeViewModel>{
    GetViewUniqueId(): string {
        return "V-905C5CC6-09E8-4481-80A6-E28FAE880467"
    }
    loadHtml(): string {
        let element = require('./jsCode.html').default;
        let style = require('./jsCode.less');
        return element;
    }
    constructor() {
       super();
    }
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;

}
